import React from 'react';

import { ReactComponent as RedirectIcon } from 'pages/Teachers/StudentListV2/assets/redirect-icon.svg';

import styles from './styles.module.scss';

const ProgressBar = ({
  student,
  averagePercentage,
  goalInformation,
  averageTargetAccuracy,
  isSubRow = false,
  handleRowClick
}) => {
  const percentage = averagePercentage;

  let colorClass = styles.fillGreen;
  if (percentage < averageTargetAccuracy / 2) colorClass = styles.fillRed;
  else if (percentage < averageTargetAccuracy) colorClass = styles.fillYellow;

  if (percentage === 0 && goalInformation !== 'Missing') {
    colorClass = styles.fillGray;
  }

  return (
    <div className={styles.progressWrapper}>
      <div className={styles.score}>
        {percentage === 0 && goalInformation === 'Missing' ? null : (
          <>
            <div className={styles.barTrack}>
              <div
                className={`${styles.barFill} ${colorClass}`}
                style={{ width: `${percentage}%` }}
              />
            </div>
            <span className={styles.progressText}>{`${percentage}% AVG`}</span>
          </>
        )}
      </div>

      {(student.sections.length === 0 || isSubRow) && (
        <RedirectIcon
          className={styles.redirectIcon}
          onClick={handleRowClick}
        />
      )}
    </div>
  );
};

export default ProgressBar;
